import React, { FC, useEffect } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMenuDisplay } from '../../../../states/containers/setting/systemSlice'
import { RootState } from '../../../../states/containers/store'
import MenuDisplay from '../../../components/setting/MenuDisplay'

const Index: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    login,
  } = useSelector((state: RootState) => state)

  useEffect(() => {
    if (!login.accessToken) return
    dispatch(fetchMenuDisplay())
  }, [login.accessToken])

  return (
    <section className="setting_page">
      <Helmet>
        <title>{`Qasee - 設定 - 共通設定 - ${t("setting.measurement.caption")}`}</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        共通設定
        &nbsp;&gt;&nbsp;
        {t("setting.measurement.caption")}
        &nbsp;
      </section>
      <section className="page_header">
        <h1>{t("setting.measurement.caption")}</h1>
      </section>
      <section className="page_description">
        <p>
          QaseeClientの操作を制限して、ユーザによる計測停止を行えないようにできます。
        </p>
        <p>
          ※Windows版はバージョン1.8.0以降、macOS版は1.7.0以降で有効です
        </p>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-detail">
            <MenuDisplay />
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
